import img1 from "../../assets/Images/Accounting/Profit and Loss.png"

export default function ProfitLoss() {
    return (
        <section id="profit-loss" className="space-y-16">

            {/* HEADER / OVERVIEW */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    6. Profit & Loss
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    The Profit & Loss module summarizes income and expenses over a selected
                    period to determine the net profit or loss of the business.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-3">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        The Profit & Loss statement (also called Income Statement) measures
                        business performance by comparing revenues against expenses within
                        a specific date range.
                    </p>
                </section>
            </section>

            {/* DATE FILTER */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">Date Range Selection</h3>
                    <p className="text-slate-600 mb-4">
                        Select a start and end date to generate the Profit & Loss report for
                        the chosen period.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>From Date</li>
                        <li>To Date</li>
                        <li>Filter button recalculates income & expenses</li>
                    </ul>
                </div>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* EXPORT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Export & Print</h3>
                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Print Profit & Loss</li>
                    <li>Export to Excel</li>
                    <li>Export to PDF</li>
                </ul>
            </section>

            {/* INCOME */}
            <section className="bg-green-50 border border-green-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2 text-green-700">Income</h3>

                <p className="text-slate-600 mb-3">
                    This section lists all income accounts generated during the selected
                    period.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Account name</li>
                    <li>Income amount</li>
                    <li>Total Income calculation</li>
                </ul>
            </section>

            {/* EXPENSE */}
            <section className="bg-red-50 border border-red-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2 text-red-700">Expenses</h3>

                <p className="text-slate-600 mb-3">
                    This section displays all expenses recorded during the selected period.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Expense account</li>
                    <li>Expense amount</li>
                    <li>Total Expense calculation</li>
                </ul>
            </section>

            {/* NET PROFIT */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Net Profit / Loss</h3>

                <p className="text-slate-600">
                    Net Profit is calculated as:
                </p>

                <p className="mt-2 font-medium text-slate-800">
                    Total Income − Total Expense
                </p>

                <p className="text-slate-600 mt-3">
                    A positive value indicates profit, while a negative value represents
                    a loss.
                </p>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Why Profit & Loss Matters</h3>
                <p className="text-slate-600 max-w-3xl">
                    The Profit & Loss report helps owners evaluate business performance,
                    control costs, plan growth, and make informed financial decisions.
                </p>
            </section>

        </section>
    );
}
